import { render, staticRenderFns } from "./orderStatementDetailPage.vue?vue&type=template&id=8c9d36e6&"
import script from "./orderStatementDetailPage.vue?vue&type=script&lang=ts&"
export * from "./orderStatementDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports